module.exports = __webpack_public_path__ + "img/9.b613f21c.jpg";